import { render } from "./FormatCreate.vue?vue&type=template&id=24a2682a"
import script from "./FormatCreate.vue?vue&type=script&lang=js"
export * from "./FormatCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__